// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-index-wrapper-bqhrc{display:grid;grid-gap:24px}.pages-info-__slug-index-pageWrapper-cbjnu{padding-bottom:48px}.pages-info-__slug-index-pageWrapper-cbjnu.pages-info-__slug-index-mobile-baznj{padding-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-info-__slug-index-wrapper-bqhrc",
	"pageWrapper": "pages-info-__slug-index-pageWrapper-cbjnu",
	"mobile": "pages-info-__slug-index-mobile-baznj"
};
module.exports = ___CSS_LOADER_EXPORT___;
